export const TOKEN = {
  name: 'FISHECOIN',
  ticker: '$FISHE',
  tagline: 'Fish Is Swimming Higher Everytime',
  acronym: [
    { letter: 'F', word: 'Fish' },
    { letter: 'I', word: 'Is' },
    { letter: 'S', word: 'Swimming' },
    { letter: 'H', word: 'Higher' },
    { letter: 'E', word: 'Everytime' },
  ],
  contract: 'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump',
  chain: 'SOLANA',
  coinImage: 'https://customer-assets-jt897jd0.emergentagent.net/job_be87243d-d970-4eef-898b-2603bcaa8df8/artifacts/86lqj9ko_GOLDY.png',
};

export const LIVE_STATS = {
  mcap: '$42.18M',
  change24h: '+8.4%',
  price: '$0.04212',
  liq: '$2.11M',
  holders: '—',
};

export const LINKS = {
  pumpfun: `https://pump.fun/coin/${'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump'}`,
  fomo: `https://fomo.family/tokens/solana/${'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump'}`,
  moonshot: `https://moonshot.com/FISHE`,
  twitter: 'https://x.com/',
  telegram: 'https://t.me/',
  dexscreener: `https://dexscreener.com/solana/${'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump'}`,
  dextools: `https://www.dextools.io/app/en/solana/pair-explorer/${'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump'}`,
  solscan: `https://solscan.io/token/${'FCmzSLNbas76Z6xjA2ZTowNN34VbEynwBiMN2okrpump'}`,
  academy: '#',
};

export const CHAPTERS = [
  { num: 'I', title: 'Surface' },
  { num: 'II', title: 'The Lineage' },
  { num: 'III', title: 'The Coin' },
  { num: 'IV', title: 'The Ascent' },
  { num: 'V', title: 'The School' },
  { num: 'VI', title: 'The Law' },
  { num: 'VII', title: 'The Number' },
  { num: 'VIII', title: 'The Ritual' },
  { num: 'IX', title: 'Yours' },
];

export const ASCENT_STOPS = [
  {
    depth: '0 m',
    zone: 'Coral Reef Paradise',
    label: 'THE SURFACE',
    body: 'Sunlit tier-1 exchanges. Merch, films, a global school of holders. FISHE breaks into daylight and never looks back.',
    tone: 'paradise',
  },
  {
    depth: '-200 m',
    zone: 'Sunlight Zone',
    label: 'VIRAL MOMENTUM',
    body: 'Trending on X, screens in every trader chat. First mainstream headline. The current turns into a rip-tide upward.',
    tone: 'sun',
  },
  {
    depth: '-1,000 m',
    zone: 'Twilight Zone',
    label: 'CEX LISTINGS',
    body: 'First centralized listings light up the water. Charts show a clean staircase — the school starts to shimmer.',
    tone: 'twilight',
  },
  {
    depth: '-4,000 m',
    zone: 'Midnight Zone',
    label: 'COMMUNITY IGNITION',
    body: 'The first thousand believers find each other in the dark. Memes, threads, telegram sonar pings — the reef takes shape.',
    tone: 'midnight',
  },
  {
    depth: '-6,000 m',
    zone: 'Abyssal Zone',
    label: 'FAIR LAUNCH',
    body: 'One billion scales seeded on pump.fun. Zero presale, zero team bag, zero permission. Every wallet starts at the same reef.',
    tone: 'abyss',
  },
  {
    depth: '-10,984 m',
    zone: 'Mariana Trench Floor',
    label: 'THE SPARK',
    body: 'A gold bar rests where no light has ever fallen. A fin flickers. FISHE opens its eyes at the deepest point on Earth.',
    tone: 'trench',
  },
];

export const LAWS = [
  {
    id: '01',
    title: 'Fair born',
    body: 'Launched on pump.fun. No presale, no team allocation, no insider bags. Every wallet started at the same bowl.'
  },
  {
    id: '02',
    title: 'Supply sealed',
    body: 'The mint authority is revoked. One billion, and not a single coin more, ever, for anyone.'
  },
  {
    id: '03',
    title: 'Pool burned',
    body: 'The liquidity pool is burned. There is no rug to pull, because there is no one holding the rug.'
  },
  {
    id: '04',
    title: 'Nothing taken',
    body: '0% buy tax, 0% sell tax. Gold sinks eventually, but never at the checkout.'
  }
];

export const STEPS = [
  {
    id: '01',
    title: 'Set up a wallet',
    body: 'Install Phantom or Solflare. Write the recovery phrase on paper and keep it offline. Never type it into any website. Not even this one.'
  },
  {
    id: '02',
    title: 'Add SOL to your wallet',
    body: 'Buy SOL on an exchange and send it to your own wallet address, or use the buy option inside the wallet app. Leave a little SOL for network fees.'
  },
  {
    id: '03',
    title: 'Buy $FISHE',
    body: 'Open pump.fun, FOMO or Moonshot. Verify the contract address character by character, then swap. The dive begins.'
  }
];

export const IMAGES = {
  heroBg: 'https://images.unsplash.com/photo-1719042575585-e9d866f43210?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxkYXJrJTIwY29yYWwlMjByZWVmJTIwc3VuJTIwcmF5c3xlbnwwfHx8fDE3OTA3MzY1MDV8MA&ixlib=rb-4.1.0&q=85',
  reefParadise: 'https://images.unsplash.com/photo-1708649290066-5f617003b93f?w=1600&q=85',
  ambient: 'https://images.unsplash.com/photo-1632061684048-34a67dc24372?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxkZWVwJTIwc2VhJTIwdW5kZXJ3YXRlciUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3OTA3MzY1MDV8MA&ixlib=rb-4.1.0&q=85',
  treasure: 'https://images.unsplash.com/photo-1768429670472-c37090eb7e37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxzdW5rZW4lMjB0cmVhc3VyZXxlbnwwfHx8fDE3OTA3MzUyOTF8MA&ixlib=rb-4.1.0&q=85',
  goldfish: 'https://images.unsplash.com/photo-1585936529565-1871537209e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxnb2xkZmlzaCUyMHN3aW1taW5nfGVufDB8fHx8MTc5MDczNTI4Mnww&ixlib=rb-4.1.0&q=85',
  darkOcean: 'https://images.unsplash.com/photo-1598717735549-3d9047bd0eb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwb2NlYW4lMjBnb2xkfGVufDB8fHx8MTc5MDczNTI5MXww&ixlib=rb-4.1.0&q=85',
};
